var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bonoActual)?_c('div',{staticClass:"home mx-auto"},[_c('Landing',{attrs:{"datos":_vm.bonoActual}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }